<template>
  <div class="animated revealUp">
    <div class="white-wrapper">
      <div class="d-flex justify-content-between">
        <div class="section-title">
          {{ $t("Cinema Tax Screen Analysis Report") }}
          <!-- <span>as per show date</span> -->
        </div>
        <div class="d-flex align-items-center">
          <div class="d-flex align-item-center">
            <input value="1" type="radio" v-model="lang_id" />
            <span class="ml-1">English</span>
          </div>
          <div class="d-flex align-item-center ml-2">
            <input value="2" type="radio" v-model="lang_id" />

            <span class="ml-1">العربية</span>
          </div>
        </div>
      </div>
      <small
        ><em>{{ $t("* As Per Show Date") }}</em></small
      >
      <div class="mt-3 mb-2">
        <div class="row">
          <div class="col-12 col-md-6 col-lg-3 col-xl-3 align-self-center mb-3">
            <div class="dropdown-curve-container">
              <label
                :class="
                  dropDown.selectedCinema && dropDown.selectedCinema
                    ? 'shift-up'
                    : 'font-weight-bold'
                "
                >{{ $t("select") }} {{ $tc("cinema", 1) }}</label
              >
              <multiselect
                :disabled="isRoleID"
                :options="dropDown.cinemas"
                v-model="dropDown.selectedCinema"
                :searchable="true"
                label="cine_name"
                track-by="cine_id"
                placeholder=""
                @input="onSelectCinema($event)"
                :allowEmpty="false"
                :showLabels="false"
              ></multiselect>
            </div>
          </div>
        
          <div class="col-12 col-md-6 col-lg-2 col-xl-2 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <!-- <button class="btn-clearDate" v-if="fromDate">
                              ✖
                            </button> -->
                <Datepicker
                  :monday-first="true"
                  type="date"
                  ref="programaticOpen"
                  v-model="fromDate"
                  v-validate="'required'"
                  @selected="onChangeDate($event, 'from')"
                ></Datepicker>
                <label :class="fromDate ? 'active' : ''">
                  <!-- {{ $t("show") }} -->
                  {{ $t("fromdate") }}
                </label>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-6 col-lg-2 col-xl-2 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <!-- <button class="btn-clearDate" v-if="toDate">
                              ✖
                            </button> -->
                <Datepicker
                  :monday-first="true"
                  ref="programaticOpen"
                  v-model="toDate"
                  v-validate="'required'"
                >
                </Datepicker>
                <label :class="toDate ? 'active' : ''">
                  <!-- {{ $t("show") }}  -->
                  {{ $t("todate") }}</label
                >
              </div>
            </div>
          </div>

            <!-- show time filter -->
                                         <div class="position-relative col-lg-3 col-xl-2 mb-2">
                                           <vue-timepicker manual-input
                                            v-model="start_time"
                                             id="starttime"
                                             name="starttime"
                                             :placeholder="$tc('starttime')"
                                             format="HH:mm" 
                                             class="time_picker" 
                                             input-width="100%" auto-scroll
                                             lazy ></vue-timepicker>
                                         </div>
                            
                       
                                 <div class="position-relative col-lg-3 col-xl-2 mb-2">
                         <vue-timepicker
                           manual-input
                           v-model="end_time"
                           id="endtime"
                           name="endtime"
                           :placeholder="$tc('endtime')"
                           format="HH:mm"
                           class="time_picker"
                           input-width="100%"
                           auto-scroll
                           lazy
                         />
                       </div>
                      <!-- show time filter -->

                      <!-- Screen Filter -->
                      <div class="col-12 col-md-6 col-lg-2 col-xl-2 align-self-center mb-3">
            <div class="dropdown-curve-container">
               <label :class="selectedScreen && selectedScreen.length > 0 ? 'shift-up' : 'font-weight-bold'">
              {{ selectedScreen && selectedScreen.length > 0 ? $t("Screens") : $t("All Screens") }}
              </label>
              <multiselect
                :options="screenList"
                v-model="selectedScreen"
                placeholder=""
                label="screen_name"
                :multiple="true"
                :close-on-select="false"
                track-by="screen_id"
              ></multiselect>
            </div>
          </div>
                       <!-- Screen Filter -->

                          <!-- Movie Filter -->
                                  <div class="col-lg-6 col-xl-3 align-self-center mb-3">
                                          <div class="dropdown-curve-container">
                                            <label :class="selectedMovieName && selectedMovieName.length > 0 ? 'shift-up' : 'font-weight-bold'">
                                              {{ selectedMovieName && selectedMovieName.length > 0 ? $t("Movies") : $t("All Movies") }}
                                            </label>
                                            <multiselect v-model="selectedMovieName" :options="allMovieNames" track-by="movie_name"
                                              label="movie_name" :disabled="isRoleID" :searchable="true" placeholder="Movies" :multiple="true">
                                            </multiselect>
                                          </div>
                                        </div>
                               <!-- Movie Filter -->

          <div class="col-12 col-md-6 col-lg-6 col-xl-2 align-self-center mb-3">
            <button class="btn-blue-lg w-100" @click="onSubmit">
              {{ $t("fetch") }}
            </button>
          </div>
        </div>
      </div>

      <div
        v-if="showDateData.length > 0"
        class="mr-3 w-100 align-self-center mb-3 d-flex justify-content-end align-items-center"
      >
        <div class="mx-1">{{ $t("download") }} {{ $t("as") }}</div>

        <img
          @click="getCinemaTaxScreenAnalysisReport('Y', 'N')"
          class="cursor-pointer"
          height="25"
          src="@/assets/img/icons/pdf-icon.svg"
          width="25"
        />

        <img
          @click="getCinemaTaxScreenAnalysisReport('N', 'Y')"
          class="cursor-pointer ml-1"
          height="25"
          src="@/assets/img/icons/excel.svg"
          width="25"
        />
      </div>

      <div class="swc-report">
  <table
    class="swc-report-table swc_table_header"
    :class="
      lang_id == 2
        ? 'swc-report-table reverse-order '
        : 'swc-report-table order '
    "
    border="1"
  >
    <tbody v-if="showDateData.length">
      <template v-for="showDate in showDateData">
        <template v-for="screen in showDate.showDateData">
          <tr
  v-if="screen.finalReport.length > 0 || screen.initialReport.length > 0"
  :class="[
    lang_id == 2 ? 'text-right swc-report-table reverse-order' : 'text-left swc-report-table order',
    'font-weight-bold'
  ]"
  style="background-color: #B9D9EB;"
>
  <td colspan="1">{{ trans("screen", lang_id) }}: {{ screen.screen_name }}</td>
  <td colspan="1">{{ trans("forDays", lang_id) }}: {{ showDate.show_date }}</td>
  <td colspan="17"></td>
</tr>

          <tr class="bg-lightgrey">
            <th>{{ trans("showTime", lang_id) }}</th>
            <th>{{ trans("movie", lang_id) }}</th>
            <th>{{ trans("type", lang_id) }}</th>
            <th>{{ trans("productioncompany", lang_id) }}</th>
            <th>{{ trans("distributioncompany", lang_id) }}</th>
            <th>{{ trans("ticketcosttotal", lang_id) }}</th>
            <th>{{ trans("ticketcostforentry", lang_id) }}</th>
            <th>{{ trans("ticketscount", lang_id) }}</th>
            <th>{{ trans("ticketscosttotal", lang_id) }}</th>
            <th>{{ trans("ticketscostforentry", lang_id) }}</th>
            <th>{{ trans("amusementtax", lang_id) }}</th>
            <th colspan="6">{{ trans("Additionalfees", lang_id) }}</th>
            <th>{{ trans("taxtotal", lang_id) }}</th>
            <th></th>
          </tr>
          <tr class="inner-header bg-lightgrey" >
            <th colspan="11"></th>
            <th>{{ trans("socialsubside", lang_id) }}</th>
            <th>{{ trans("cinemasubside", lang_id) }}</th>
            <th>{{ trans("policesubside", lang_id) }}</th>
            <th>{{ trans("daransubside", lang_id) }}</th>
            <th>{{ trans("servicessubside", lang_id) }}</th>
            <th>{{ trans("sports", lang_id) }}</th>
            <th></th>
            <th></th>
          </tr>

          <template v-if="screen.finalReport.length > 0">
              <tr v-for="show in screen.finalReport">
                <td class="text-left">
                  {{ show.show_time }}

                  <div class="float-right p-0">
                    <b-dropdown
                      right
                      variant="transparent"
                      id="dropdown-dropup"
                      boundary="viewport"
                      size="sm"
                      no-caret
                    >
                      <template #button-content>
                        <span
                          class="icon-eye blue-icon mx-1 float-right"
                        ></span>
                      </template>
                      <b-dropdown-item
                        @click.prevent.stop="onViewSeatLayout(show)"
                        :title="'View Seat Layout'"
                      >
                        View Seat layout
                      </b-dropdown-item>
                      <b-dropdown-item
                        @click.prevent.stop="onViewTransactions(show)"
                        :title="'View Transactions'"
                      >
                        View Transactions
                      </b-dropdown-item>
                    </b-dropdown>
                  </div>
                </td>
                <td class="text-left">
                  {{
                    lang_id == 1
                      ? show.movie_title
                      : show.movie_title_4
                      ? show.movie_title_2
                      : show.movie_title
                  }}
                </td>
                <td class="text-left">
                  {{
                    show.is_foreign_movie == "Y"
                      ? trans("foreign", lang_id)
                      : trans("egyptian", lang_id)
                  }}
                </td>
                <td class="text-left">{{ show.production_name }}</td>
                <td class="text-left">{{ show.distributor_name }}</td>
                <td class="text-right">
                  {{ parseFloat(show.ticket_gross).toFixed(2) }}
                </td>
                <td class="text-right">
                  {{ parseFloat(show.ticket_net).toFixed(2) || 0 }}
                </td>
                <td class="text-right">{{ show.tickets_no || 0 }}</td>
                <td class="text-right">
                  {{ parseFloat(show.tickets_gross || 0).toFixed(2) || 0 }}
                </td>
                <td class="text-right">
                  {{ parseFloat(show.tickets_net || 0).toFixed(2) || 0 }}
                </td>
                <td class="text-right">
                  {{ parseFloat(show.entertainment_tax || 0).toFixed(2) }}
                </td>
                <td class="text-right">
                  {{
                    parseFloat(show.fixed_fees.social || 0).toFixed(2) || 0
                  }}
                </td>
                <td class="text-right">
                  {{
                    parseFloat(show.fixed_fees.cinema || 0).toFixed(2) || 0
                  }}
                </td>
                <td class="text-right">
                  {{
                    parseFloat(show.fixed_fees.police || 0).toFixed(2) || 0
                  }}
                </td>
                <td class="text-right">
                  {{
                    parseFloat(show.fixed_fees.daran || 0).toFixed(2) || 0
                  }}
                </td>
                <td class="text-right">
                  {{
                    parseFloat(show.fixed_fees.services || 0).toFixed(2) ||
                    0
                  }}
                </td>
                <td class="text-right">
                  {{
                    parseFloat(show.fixed_fees.sports || 0).toFixed(2) || 0
                  }}
                </td>
                <td class="text-right">
                  {{ parseFloat(show.total_tax || 0).toFixed(2) || 0 }}
                </td>
                <td class="text-right">
                  {{ trans("finalreport", lang_id) }}
                </td>
              </tr>
              <!-- <tr
            v-if="screen.finalReport.length > 0 || screen.initialReport.length > 0"
            class="text-left font-weight-bold"
          >
            <td colspan="7" class="text-left">
              {{ trans("total", lang_id) }}
            </td>
            <td class="text-right">
              {{ screen.grandTotal.tickets_no || 0 }}
            </td>
            <td class="text-right">
              {{
                parseFloat(screen.grandTotal.tickets_gross || 0).toFixed(2) ||
                0.0
              }}
            </td>
            <td class="text-right">
              {{
                parseFloat(screen.grandTotal.tickets_net || 0).toFixed(2) || 0.0
              }}
            </td>
            <td class="text-right">
              {{
                parseFloat(screen.grandTotal.entertainment_tax || 0).toFixed(2) ||
                0.0
              }}
            </td>
            <td class="text-right">
              {{
                parseFloat(screen.grandTotal.social || 0).toFixed(2) || 0.0
              }}
            </td>
            <td class="text-right">
              {{
                parseFloat(screen.grandTotal.cinema || 0).toFixed(2) || 0.0
              }}
            </td>
            <td class="text-right">
              {{
                parseFloat(screen.grandTotal.police || 0).toFixed(2) || 0.0
              }}
            </td>
            <td class="text-right">
              {{
                parseFloat(screen.grandTotal.daran || 0).toFixed(2) || 0.0
              }}
            </td>
            <td class="text-right">
              {{
                parseFloat(screen.grandTotal.services || 0).toFixed(2) || 0.0
              }}
            </td>
            <td class="text-right">
              {{
                parseFloat(screen.grandTotal.sports || 0).toFixed(2) || 0.0
              }}
            </td>
            <td class="text-right">
              {{
                parseFloat(screen.grandTotal.total_tax || 0).toFixed(2) || 0.0
              }}
            </td>
            <td></td>
          </tr> -->

            </template>

            <template v-if="screen.initialReport.length > 0">
              <tr v-for="show in screen.initialReport">
                <td class="text-left">
                  {{ show.show_time }}
                  <div class="float-right p-0">
                    <b-dropdown
                      right
                      variant="transparent"
                      id="dropdown-dropup"
                      boundary="viewport"
                      size="sm"
                      no-caret
                    >
                      <template #button-content>
                        <span
                          class="icon-eye blue-icon mx-1 float-right"
                        ></span>
                      </template>
                      <b-dropdown-item
                        @click.prevent.stop="onViewSeatLayout(show)"
                        :title="'View Seat Layout'"
                      >
                        View Seat layout
                      </b-dropdown-item>
                      <b-dropdown-item
                        @click.prevent.stop="onViewTransactions(show)"
                        :title="'View Transactions'"
                      >
                        View Transactions
                      </b-dropdown-item>
                    </b-dropdown>
                  </div>
                </td>
                <td class="text-left">
                  {{
                    lang_id == 1
                      ? show.movie_title
                      : show.movie_title_4
                      ? show.movie_title_2
                      : show.movie_title
                  }}
                </td>
                <td class="text-left">
                  {{
                    show.is_foreign_movie == "Y"
                      ? trans("foreign", lang_id)
                      : trans("egyptian", lang_id)
                  }}
                </td>
                <td class="text-left">{{ show.production_name }}</td>
                <td class="text-left">{{ show.distributor_name }}</td>
                <td class="text-right">
                  {{ parseFloat(show.ticket_gross || 0).toFixed(2) }}
                </td>
                <td class="text-right">
                  {{ parseFloat(show.ticket_net || 0).toFixed(2) || 0 }}
                </td>
                <td class="text-right">{{ show.tickets_no || 0 }}</td>
                <td class="text-right">
                  {{ parseFloat(show.tickets_gross || 0).toFixed(2) || 0 }}
                </td>
                <td class="text-right">
                  {{ parseFloat(show.tickets_net || 0).toFixed(2) || 0 }}
                </td>
                <td class="text-right">
                  {{ parseFloat(show.entertainment_tax || 0).toFixed(2) }}
                </td>
                <td class="text-right">
                  {{
                    parseFloat(show.fixed_fees.social || 0 || 0).toFixed(
                      2
                    ) || 0
                  }}
                </td>
                <td class="text-right">
                  {{
                    parseFloat(show.fixed_fees.cinema || 0 || 0).toFixed(
                      2
                    ) || 0
                  }}
                </td>
                <td class="text-right">
                  {{
                    parseFloat(show.fixed_fees.police || 0 || 0).toFixed(
                      2
                    ) || 0
                  }}
                </td>
                <td class="text-right">
                  {{
                    parseFloat(show.fixed_fees.daran || 0 || 0).toFixed(
                      2
                    ) || 0
                  }}
                </td>
                <td class="text-right">
                  {{
                    parseFloat(show.fixed_fees.services || 0).toFixed(2) ||
                    0
                  }}
                </td>
                <td class="text-right">
                  {{
                    parseFloat(show.fixed_fees.sports || 0).toFixed(2) || 0
                  }}
                </td>
                <td class="text-right">
                  {{ parseFloat(show.total_tax || 0).toFixed(2) || 0 }}
                </td>
                <td class="text-right">
                  {{ trans("ongoingreserve", lang_id) }}
                </td>
              </tr>

              <!-- <tr
            v-if="screen.finalReport.length > 0 || screen.initialReport.length > 0"
            class="text-left font-weight-bold"
          >
            <td colspan="7" class="text-left">
              {{ trans("total", lang_id) }}
            </td>
            <td class="text-right">
              {{ screen.grandTotal.tickets_no || 0 }}
            </td>
            <td class="text-right">
              {{
                parseFloat(screen.grandTotal.tickets_gross || 0).toFixed(2) ||
                0.0
              }}
            </td>
            <td class="text-right">
              {{
                parseFloat(screen.grandTotal.tickets_net || 0).toFixed(2) || 0.0
              }}
            </td>
            <td class="text-right">
              {{
                parseFloat(screen.grandTotal.entertainment_tax || 0).toFixed(2) ||
                0.0
              }}
            </td>
            <td class="text-right">
              {{
                parseFloat(screen.grandTotal.social || 0).toFixed(2) || 0.0
              }}
            </td>
            <td class="text-right">
              {{
                parseFloat(screen.grandTotal.cinema || 0).toFixed(2) || 0.0
              }}
            </td>
            <td class="text-right">
              {{
                parseFloat(screen.grandTotal.police || 0).toFixed(2) || 0.0
              }}
            </td>
            <td class="text-right">
              {{
                parseFloat(screen.grandTotal.daran || 0).toFixed(2) || 0.0
              }}
            </td>
            <td class="text-right">
              {{
                parseFloat(screen.grandTotal.services || 0).toFixed(2) || 0.0
              }}
            </td>
            <td class="text-right">
              {{
                parseFloat(screen.grandTotal.sports || 0).toFixed(2) || 0.0
              }}
            </td>
            <td class="text-right">
              {{
                parseFloat(screen.grandTotal.total_tax || 0).toFixed(2) || 0.0
              }}
            </td>
            <td></td>
          </tr> -->

            </template>

            <tr >
              <td colspan="19"></td>
            </tr>

            <tr style="background-color: #F0F8FF; border: transparent;"
            :class="[
    lang_id == 2 ? 'text-right swc-report-table reverse-order' : 'text-left swc-report-table order',
    'font-weight-bold'
  ]"
            >
              <td >
                {{ trans("total", lang_id) }}  {{ screen.screen_name }}   
</td>
<td>{{ trans("forDays", lang_id) }}: {{ moment(fromDate).format('YYYY-MM-DD') }} - {{ moment(toDate).format('YYYY-MM-DD') }}</td>
<td></td>
<td></td>
<td></td>
<td></td>
<td></td>
<td></td>
<td></td>
<td></td>
<td></td>
<td></td>
<td></td>
<td></td>
<td></td>
<td></td>
<td></td>
<td></td>
<td></td>
            </tr>

            <tr class="bg-lightgrey">
            <th colspan="7"></th>
            <th>{{ trans("ticketscount", lang_id) }}</th>
            <th>{{ trans("ticketscosttotal", lang_id) }}</th>
            <th>{{ trans("ticketscostforentry", lang_id) }}</th>
            <th>{{ trans("amusementtax", lang_id) }}</th>
            <th colspan="6">{{ trans("Additionalfees", lang_id) }}</th>
            <th>{{ trans("taxtotal", lang_id) }}</th>
            <th></th>
          </tr>
          <tr class="inner-header bg-lightgrey" >
            <th colspan="11"></th>
            <th>{{ trans("socialsubside", lang_id) }}</th>
            <th>{{ trans("cinemasubside", lang_id) }}</th>
            <th>{{ trans("policesubside", lang_id) }}</th>
            <th>{{ trans("daransubside", lang_id) }}</th>
            <th>{{ trans("servicessubside", lang_id) }}</th>
            <th>{{ trans("sports", lang_id) }}</th>
            <th></th>
            <th></th>
          </tr>

          <tr
            v-if="screen.finalReport.length > 0 || screen.initialReport.length > 0"
            class=" bg-lightgrey text-left"
          >
            <td colspan="7" class="text-left">
              {{ trans("total", lang_id) }}
            </td>
            <td class="text-right">
              {{ screen.grandTotal.tickets_no || 0 }}
            </td>
            <td class="text-right">
              {{
                parseFloat(screen.grandTotal.tickets_gross || 0).toFixed(2) ||
                0.0
              }}
            </td>
            <td class="text-right">
              {{
                parseFloat(screen.grandTotal.tickets_net || 0).toFixed(2) || 0.0
              }}
            </td>
            <td class="text-right">
              {{
                parseFloat(screen.grandTotal.entertainment_tax || 0).toFixed(2) ||
                0.0
              }}
            </td>
            <td class="text-right">
              {{
                parseFloat(screen.grandTotal.social || 0).toFixed(2) || 0.0
              }}
            </td>
            <td class="text-right">
              {{
                parseFloat(screen.grandTotal.cinema || 0).toFixed(2) || 0.0
              }}
            </td>
            <td class="text-right">
              {{
                parseFloat(screen.grandTotal.police || 0).toFixed(2) || 0.0
              }}
            </td>
            <td class="text-right">
              {{
                parseFloat(screen.grandTotal.daran || 0).toFixed(2) || 0.0
              }}
            </td>
            <td class="text-right">
              {{
                parseFloat(screen.grandTotal.services || 0).toFixed(2) || 0.0
              }}
            </td>
            <td class="text-right">
              {{
                parseFloat(screen.grandTotal.sports || 0).toFixed(2) || 0.0
              }}
            </td>
            <td class="text-right">
              {{
                parseFloat(screen.grandTotal.total_tax || 0).toFixed(2) || 0.0
              }}
            </td>
            <td></td>
          </tr>

          <tr style="height: 30px;">

</tr>

          <template
            v-if="!screen.finalReport.length && !screen.initialReport.length"
          >
            <tr>
              <td colspan="11">No Records</td>
              <td colspan="8"></td>
            </tr>
          </template>
        </template>
      </template>

      <!-- Grand total -->
       <tr style="background-color: #F0F8FF;"
       :class="[
    lang_id == 2 ? 'text-right swc-report-table reverse-order' : 'text-left swc-report-table order',
    'font-weight-bold'
  ]"
       >
        <td colspan="19">
          {{ trans("total", lang_id) }} {{ trans("forDays", lang_id) }}: {{moment(fromDate).format("YYYY-MM-DD") + "    " + "-" + "    " + moment(toDate).format("YYYY-MM-DD")}}
        </td>
       </tr>

      <tr class="bg-lightgrey">
            <th colspan="7"></th>
            <th>{{ trans("ticketscount", lang_id) }}</th>
            <th>{{ trans("ticketscosttotal", lang_id) }}</th>
            <th>{{ trans("ticketscostforentry", lang_id) }}</th>
            <th>{{ trans("amusementtax", lang_id) }}</th>
            <th colspan="6">{{ trans("Additionalfees", lang_id) }}</th>
            <th>{{ trans("taxtotal", lang_id) }}</th>
            <th></th>
          </tr>
          <tr class="inner-header bg-lightgrey" >
            <th colspan="11"></th>
            <th>{{ trans("socialsubside", lang_id) }}</th>
            <th>{{ trans("cinemasubside", lang_id) }}</th>
            <th>{{ trans("policesubside", lang_id) }}</th>
            <th>{{ trans("daransubside", lang_id) }}</th>
            <th>{{ trans("servicessubside", lang_id) }}</th>
            <th>{{ trans("sports", lang_id) }}</th>
            <th></th>
            <th></th>
          </tr>

      <tr class="bg-lightgrey text-left">
        <td colspan="7" class="text-left">
          {{ trans("grandtotal", lang_id) }}
        </td>
        <td class="text-right">
          {{ grandTotal.tickets_no || 0 }}
        </td>
        <td class="text-right">
          {{ parseFloat(grandTotal.tickets_gross || 0).toFixed(2) || 0.0 }}
        </td>
        <td class="text-right">
          {{ parseFloat(grandTotal.tickets_net || 0).toFixed(2) || 0.0 }}
        </td>
        <td class="text-right">
          {{
            parseFloat(grandTotal.entertainment_tax || 0).toFixed(2) || 0.0
          }}
        </td>
        <td class="text-right">
          {{ parseFloat(grandTotal.social || 0).toFixed(2) || 0.0 }}
        </td>
        <td class="text-right">
          {{ parseFloat(grandTotal.cinema || 0).toFixed(2) || 0.0 }}
        </td>
        <td class="text-right">
          {{ parseFloat(grandTotal.police || 0).toFixed(2) || 0.0 }}
        </td>
        <td class="text-right">
          {{ parseFloat(grandTotal.daran || 0).toFixed(2) || 0.0 }}
        </td>
        <td class="text-right">
          {{ parseFloat(grandTotal.services || 0).toFixed(2) || 0.0 }}
        </td>
        <td class="text-right">
          {{ parseFloat(grandTotal.sports || 0).toFixed(2) || 0.0 }}
        </td>
        <td class="text-right">
          {{ parseFloat(grandTotal.total_tax || 0).toFixed(2) || 0.0 }}
        </td>
        <td></td>
      </tr>
    </tbody>

    <tbody v-else>
      <tr>
        <td colspan="19">No Records</td>
      </tr>
    </tbody>
  </table>
</div>



    </div>

    <ShowSeatLayoutPopup
      modalId="seatLayoutView"
      :md_id="selectedShowDetails.md_id"
      :screen_id="selectedShowDetails.screen_id"
      :ss_id="selectedShowDetails.ss_id"
      :cinema_id="selectedShowDetails.cinema_id"
      :showDetails="selectedShowDetails.showDetails"
    />

    <ScheduleWiseTransactionsPopup
      modalId="transactionView"
      :ss_id="selectedShowDetails.ss_id"
      :cinema_id="selectedShowDetails.cinema_id"
      :showDetails="selectedShowDetails.showDetails"
    />
  </div>
</template>
      
      <script>
import { BASEURL } from "@/config/index";
import MasterService from "@/services/MasterService";
import NewReportService from "../../../services/NewReportService";
import ReportsService from "@/services/NewReportService";
import moment from "moment";
import NoRecords from "@/components/Partials/NoRecords.vue";
import CinemasService from "@/services/CinemasService";
import xlsx from "json-as-xlsx";
import VueHtml2pdf from "vue-html2pdf";
import * as XLSX from "xlsx";
import { mapState, mapActions } from "vuex";
import ShowSeatLayoutPopup from "@/components/Partials/ShowSeatLayoutPopup.vue";
import ScheduleWiseTransactionsPopup from "@/components/Partials/ScheduleWiseTransactionsPopup.vue";
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";
// import LangSwitcher from "./LangSwitcher.vue";

export default {
  components: {
    NoRecords,
    VueHtml2pdf,
    ShowSeatLayoutPopup,
    ScheduleWiseTransactionsPopup,
    VueTimepicker
    // LangSwitcher,
  },
  data() {
    return {
       selectedMovieName: [],
            allMovieNames: [],
       end_time: "",
      start_time: "",
      selectedShowDetails: {
        md_id: null,
        screen_id: null,
        ss_id: null,
        cinema_id: null,
        showDetails: {
          screen_name: "",
          movie_name: "",
          ss_actual_start_date: "",
          ss_start_show_time: "",
        },
      },
      BASEURL,
      isRoleID: false,
      submitted: false,
      htmlToPdfOptions: {
        filename: this.pdfFileName,
        margin: 3,
        image: {
          type: "jpeg",
          quality: 1,
        },
        html2canvas: {
          scale: 1,
          useCORS: true,
        },
        jsPDF: {
          format: "a2",
          orientation: "landscape",
        },
      },
      dropDown: {
        cinemas: [],
        selectedCinema: null,
        selectedCinemaName: null,
        selectedCinemaId: "",
        selectedCinemaAddres: null,
      },
      fromDate: new Date(),
      toDate: new Date(),
      advancedSalesrecords: [],
      grandTotal: {},
      screenList: [],
      selectedScreen: [],
      showDateData: [],
      selectedLanguage: "en",
      lang_id: "1",
      grandTotal: {},
    };
  },
  beforeMount() {
    let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
    this.getCinemaList();
  },
  watch: {
       fromDate() {
        this.getCinemaTaxScreenAnalysisReport("N", "N", "filter");
      },
      toDate() {
        this.getCinemaTaxScreenAnalysisReport("N", "N", "filter");
      },
  },
  mounted() {},
  computed: {
    currentSelectedLanguage() {
      return this.$store.getters.GET_SELECTED_HEADER_LANGUAGE;
    },
    //
  },
  methods: {
    moment,
    onChangeDate: function (e, type){
          if(type == 'from'){
              this.toDate = new Date(e);
              this.$forceUpdate();
          }
      },
    onViewSeatLayout(filmInfo) {
      this.selectedShowDetails = {
        md_id: filmInfo["md_id"],
        screen_id: filmInfo["screen_id"],
        ss_id: filmInfo["ss_id"],
        cinema_id: this.dropDown.selectedCinemaId,
        showDetails: {
          screen_name: filmInfo["screen_name"],
          movie_name: filmInfo["movie_title"],
          ss_actual_start_date: moment(filmInfo["show_date"]).format(
            "YYYY-MM-DD"
          ),
          ss_start_show_time: filmInfo["show_time"],
        },
      };

      this.$bvModal.show("seatLayoutView");
    },
    onViewTransactions(filmInfo) {
      this.selectedShowDetails = {
        md_id: filmInfo["md_id"],
        screen_id: filmInfo["screen_id"],
        ss_id: filmInfo["ss_id"],
        cinema_id: this.dropDown.selectedCinemaId,
         showDetails: {
          screen_name: filmInfo["screen_name"],
          movie_name: filmInfo["movie_title"],
          ss_actual_start_date: moment(filmInfo["show_date"]).format(
            "YYYY-MM-DD"
          ),
          ss_start_show_time: filmInfo["show_time"],
        },
      };
      this.$bvModal.show("transactionView");
    },
    getCinemaList: function () {
      MasterService.GetCinemas()
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.dropDown.cinemas = data.Records;
            this.CinemasCopy = data.Records;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    onSelectCinema: function (event) {
      this.dropDown.selectedCinema = event;
      this.dropDown.selectedCinemaName = event.cine_name;
      this.dropDown.selectedCinemaId = event.cine_id;
      this.dropDown.selectedCinemaAddres = event.cine_address;
      this.$store.dispatch("selectDropdownCinema", event);
      this.getCinemaScreens();
    },
    async getCinemaScreens(index) {
      try {
        const response = await MasterService.GetActiveList({
          tableName: "screens",
          screen_is_active: "Y",
          cinema_id: this.dropDown.selectedCinemaId,
        });
        const { data } = response;
        if (data.status && data.Records.length > 0) {
          this.screenList = data.Records;
        } else {
          console.log("show error:", data.message);
        }
      } catch (error) {
        this._CatchError(error);
      }
    },
    onSubmit() {
      this.getCinemaTaxScreenAnalysisReport();
    },
    async getCinemaTaxScreenAnalysisReport(isPdf = "N", isExcel = "N", type="") {
      if (!this.dropDown.selectedCinemaId) {
        return this.$toasted.show("Select Cinema");
      }
      if (!this.fromDate) {
        return this.$toasted.show("Select From Date");
      }
      let loader;
      try {
        let screen_id = [];
        this.screenData = [];
        if (this.selectedScreen.length) {
          screen_id = this.selectedScreen.map((screen) => screen.screen_id);
        }
        loader = this.$loading.show();
        let payload = {
          cinema_id: this.dropDown.selectedCinemaId,
          cinema_name: this.dropDown.selectedCinemaName,
          cinema_address: this.dropDown.selectedCinemaAddres,
          fromDate: this.fromDate,
          toDate: this.toDate,
           screen_name: this.selectedScreen.map(x => x.screen_name),
          screen_id,
          isPdf,
          isExcel,
          lang_id: this.lang_id,
          language: this.selectedLanguage,
          start_time:this.start_time,
          end_time:this.end_time,
        };

          if (type === "filter") {
              payload["type"] = "filter";
            }
        
            if (this.selectedMovieName.length) {
              payload["selectedMovieName"] = this.selectedMovieName.map(item => item.movie_name);
            }

        let response = await NewReportService.getCinemaTaxScreenAnalysisReport(
          payload
        );
        const { data } = response;
        if (!data.status) {
              return this.$toasted.show(data.message);
            }
           if (type == "filter") {
                this.allMovieNames = [...data.movieNamesData];
              }
              else{  
          this.showDateData = data.Records;
          this.grandTotal = data.grandTotal;

          if (isPdf == "Y" && data.pdfPath) {
            window.open(data.pdfPath, "_blank");
          }
          if (isExcel == "Y" && data.excelPath) {
            window.open(data.excelPath, "_blank");
          }
         
          this.$toasted.show(data.message);
        }
      } catch (error) {
        console.log(error);
      } finally {
        if (loader) {
          loader.hide();
        }
      }
    },
    updateLanguage(lang) {
      this.selectedLanguage = lang;
      // console.log("this.selectedLanguage:", this.selectedLanguage);
    },
  },
};
</script>
      
      <style>
.concession-analysis-table {
  width: 100%;
  border: 1px solid #787878;
}

.concession-analysis-table thead {
  text-align: center;
  background-color: #dddedf;
}

.concession-analysis-table thead th {
  padding: 5px;
  border: 1px solid #000;
}

.concession-analysis-table tbody {
  border-bottom: 1px solid #000;
}

.concession-analysis-table tbody td {
  padding: 2.5px 5px;
  border-left: 1px solid #787878;
  border-right: 1px solid #787878;
}

.concession-analysis-table tbody td p {
  font-weight: bold;
  margin-bottom: 0;
}

.gcamp-tr td {
  width: 13%;
  border: 1px solid #000;
}

.swc-report-table {
  table-layout: auto !important;
  border: 1px solid black;
}

.swc-report-table th {
  border: 1px solid black !important;
}

.swc_table_header th {
  border: 1px solid black !important;
}
.rtl-table {
  direction: rtl;
  text-align: right;
}
.rtl-table-scroll {
  direction: rtl;
}
.text_right {
  text-align: right;
}
.reverse-order {
  direction: rtl;
}
.order {
  direction: ltr;
}
</style>


// WEBPACK FOOTER //
// src/components/Pages/ReportsContainer/cinemaTaxScreenAnalysis.vue